@if (show) {
  <div
    class="fixed bottom-0 left-0 right-0 z-[1000] flex flex-col gap-3 border-t border-[#2d1b4e] bg-[#1a0f2e] px-4 py-3 shadow-lg md:bottom-4 md:left-4 md:right-auto md:max-w-sm md:rounded-xl md:border">
    @if (isIos) {
      <p class="text-sm font-medium text-white">
        Add Handshake to your home screen: tap the <strong>Share</strong> icon at the bottom of the browser and choose <strong>Add to Home Screen</strong>.
      </p>
      <div class="flex shrink-0 justify-end">
        <button
          type="button"
          (click)="dismiss()"
          class="rounded-lg bg-[#6B4E9E] px-3 py-1.5 text-sm font-medium text-white hover:bg-[#7d5eb3]">
          Got it
        </button>
      </div>
    } @else {
      <p class="text-sm font-medium text-white">Add Handshake to your home screen for quick access.</p>
      <div class="flex shrink-0 gap-2">
        <button
          type="button"
          (click)="dismiss()"
          class="rounded-lg px-3 py-1.5 text-sm text-[#b8a0d8] hover:bg-white/10">
          Not now
        </button>
        <button
          type="button"
          (click)="install()"
          class="rounded-lg bg-[#6B4E9E] px-3 py-1.5 text-sm font-medium text-white hover:bg-[#7d5eb3]">
          Install
        </button>
      </div>
    }
  </div>
}
